module.exports = __webpack_public_path__ + "img/banner_20220830_1_kicsi.e067803b.jpg";